import {Component, OnInit} from '@angular/core';
import {OffersDataService} from '../_services/offers-data.service';
import {ActivatedRoute} from '@angular/router';
import {OfferModel} from '../_models/offer.model';
import {EnumTransformPipe} from '../../../../shared-module/enumTransform/enum-transform.pipe';
import {ProductListModel} from '../../contracts/_models/productList.model';
import {NotesListModel} from '../../contracts/_models/notesList.model';
import * as fileSaver from 'file-saver';
import pdfMake from 'pdfmake/build/pdfmake';

@Component({
    selector: 'app-view-offer',
    templateUrl: './view-offer.component.html',
    styleUrls: ['./view-offer.component.scss']
})


export class ViewOfferComponent implements OnInit {

    constructor(private contractsData: OffersDataService, private route: ActivatedRoute) {
    }

    offerData: OfferModel;
    isLoaded: boolean;

    ngOnInit() {
        this.route.params.subscribe(res => {
            const offerId = res.id
            this.contractsData.viewSingleOffer(offerId).subscribe(offerData => {
                this.offerData = offerData;
                this.isLoaded = true;
            })
        })
    }


    generatePdf() {
        const documentDefinition = this.getDocumentDefinition();
        pdfMake.createPdf(documentDefinition).open();
    }

    enumPipe = new EnumTransformPipe();

    getDocumentDefinition() {
        return {
            info: {
                title: 'ABJ-CONTRACT',
                author: 'AgribusinessJob'
            },
            // watermark: { text: 'www.agribusinessjob.ro', color: 'green', opacity: 0.1, bold: true, italics: false },
            footer: function(currentPage, pageCount) {
                return [
                    {
                        text: currentPage.toString() + ' din ' + pageCount, alignment: 'center', opacity: 0.5
                    }]},
            // header: function() {
            //     return [
            //         {text: 'Contract generat prin intermediul site-ului www.agribusinessjob.ro', alignment: 'center', opacity: 0.5, margin: [0, 15, 0, 10]}
            //     ]
            // },
            content: [
                {
                    text: 'Oferta - ' + this.offerData.docNumber,
                    style: 'bigTitle'
                },
                {
                    columns:
                        [
                            [
                                {
                                    text: 'Detalii Oferta',
                                    style: 'mediumTitle'
                                },
                                {
                                    text: 'Nume: ' + this.offerData.name
                                },
                                {
                                    text: 'Nr. contract: ' + this.offerData.docNumber
                                },
                                {
                                    text: 'Date: ' + this.offerData.offerDate
                                },
                                {
                                    text: 'Deadline: ' + this.offerData.deadline
                                },
                                {
                                    text: 'Status: ' + this.enumPipe.transform(this.offerData.status)
                                },
                            ], [
                            {
                                text: 'Detalii Client',
                                style: 'mediumTitle'
                            },
                            {
                                text: 'Nume: ' + this.offerData.clientName
                            },
                            {
                                text: 'CIF: ' + this.offerData.clientFiscalCode
                            },
                            {
                                text: 'Adresa: ' + this.offerData.clientAddress + ', ' + this.offerData.clientCity + ', ' + this.offerData.clientCountry
                            },

                        ]],
                    // optional space between columns
                    columnGap: 10
                },
                {
                    columns: [
                        [
                            {
                                text: 'Lista produse',
                                style: 'mediumTitle',
                                margin: [0, 30, 0, 5]
                            },
                            this.getProductsObject(this.offerData.productList)
                        ]
                    ]
                },
                {
                    columns: [
                        [
                            {
                                text: 'Lista notite',
                                style: 'mediumTitle',
                                margin: [0, 30, 0, 5]
                            },
                            this.getNotesObject(this.offerData.personalNotes)
                        ]
                    ]
                },
                {
                    columns: [
                        [
                            {
                                text: 'Alte observatii',
                                style: 'mediumTitle',
                                margin: [0, 30, 0, 5]
                            },
                            {
                                text: this.offerData.observation
                            }
                        ]
                    ]
                },
                {
                    columns: [
                        [
                            {
                                text: 'TOTAL',
                                style: 'totalTitle'
                            },
                            {
                                text: this.offerData.totalPrice + ' Euro',
                                style: 'totalSum'
                            }
                        ]
                    ]
                },

            ],
            styles: {
                mediumTitle: {
                    fontSize: 14,
                    bold: true,
                    margin: [0,0,0,5]
                },
                bigTitle: {
                    bold: true,
                    fontSize: 20,
                    margin: [0, 0, 0, 30],
                    alignment: 'center'
                },
                totalTitle: {
                    bold: true,
                    fontSize: 20,
                    margin: [0, 30, 0, 5],
                    decoration: 'underline',
                    alignment: 'right'
                },
                totalSum: {
                    bold: true,
                    fontSize: 20,
                    alignment: 'right'
                }
            },
        };
    }

    getProductsObject(products: ProductListModel[]) {
        if (this.offerData.productList != null) {
            return {
                table: {
                    widths: ['*', '*'],
                    body: [
                        [{
                            text: 'Nume produs',
                            style: 'tableHeader'
                        },
                            {
                                text: 'Pret',
                                style: 'tableHeader'
                            }
                        ],
                        ...products.map(ed => {
                            return [ed.name,
                                ed.price];
                        })
                    ]
                }
            };
        }
    }

    getNotesObject(notes: NotesListModel[]) {
        if (this.offerData.productList != null) {
            return {
                table: {
                    widths: ['*', '*', '*'],
                    body: [
                        [{
                            text: 'Autor',
                            style: 'tableHeader'
                        },
                            {
                                text: 'Nota',
                                style: 'tableHeader'
                            },
                            {
                                text: 'Data',
                                style: 'tableHeader'
                            }
                        ],
                        ...notes.map(ed => {
                            return [ed.authorName,
                                ed.note,
                                ed.date];
                        })
                    ]
                }
            };
        }
    }
}
